import React from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/ui/Button";

const SpecimenForm = ({ onNext, onBack, defaultValues }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues });

  const inputStyle =
    "w-full px-4 py-3 rounded-xl border text-[16px] md:text-[20px] 2xl:text-[24px] border-[#183076] focus:outline-none focus:ring-2 focus:ring-[#183076] bg-white transition-all placeholder:text-[#183076]/50";
  const labelStyle =
    "font-bold text-[#183076] text-[16px] md:text-[20px] 2xl:text-[24px]";

  return (
    <section className="w-full max-w-[1800px] mx-auto px-4">
      <div className="bg-white border rounded-[2rem] p-8 md:p-12 shadow-sm border-[#183076]">
        <h2 className="text-[20px] md:text-[24px] 2xl:text-[30px] font-bold text-[#183076]">
          Specimen Specifications
        </h2>
        <p className="text-[16px] md:text-[20px] 2xl:text-[24px] text-[#183076] mt-2 mb-[30px]">
          Define the biological requirements for your research.
        </p>

        <form
          onSubmit={handleSubmit(onNext)}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6"
        >
          <div className="flex flex-col gap-2 md:col-span-3">
            <label className={labelStyle}>Specimen Type *</label>
            <input
              {...register("specimenType", { required: true })}
              className={inputStyle}
              placeholder="e.g. Tissue, Blood"
            />
          </div>
          <div className="flex flex-col gap-2 md:col-span-3">
            <label className={labelStyle}>Indication / Cohort *</label>
            <input
              {...register("indications", { required: true })}
              className={inputStyle}
              placeholder="Enter Details"
            />
          </div>
          <div className="flex flex-col gap-2 md:col-span-2">
            <label className={labelStyle}>Quantity Required *</label>
            <input
              {...register("quantity", { required: true })}
              className={inputStyle}
              placeholder="Enter Details"
            />
          </div>
          <div className="flex flex-col gap-2 md:col-span-2">
            <label className={labelStyle}>Volume/Size per Sample *</label>
            <input
              {...register("volume", { required: true })}
              className={inputStyle}
              placeholder="Enter Details"
            />
          </div>
          <div className="flex flex-col gap-2 md:col-span-2">
            <label className={labelStyle}>Format Preferences *</label>
            <input
              {...register("format", { required: true })}
              className={inputStyle}
              placeholder="Enter Details"
            />
          </div>
          <div className="flex flex-col gap-2 md:col-span-3">
            <label className={labelStyle}>Processing Requirements</label>
            <input
              {...register("processing")}
              className={inputStyle}
              placeholder="Enter Details"
            />
          </div>
          <div className="flex flex-col gap-2 md:col-span-3">
            <label className={labelStyle}>Data Requirements</label>
            <input
              {...register("dataRequirements")}
              className={inputStyle}
              placeholder="Enter Details"
            />
          </div>

          <div className="md:col-span-full flex flex-col md:flex-row justify-center gap-4 mt-8">
            <Button
              type="button"
              onClick={onBack}
              className="px-10 py-3 border border-[#183076] text-[#183076] hover:bg-[#183076] hover:text-white rounded-full font-bold transition-colors"
            >
              Back
            </Button>
            <Button
              type="submit"
              className="px-16 py-3 bg-[#183076] text-white rounded-full font-bold border border-[#183076] transition-colors shadow-md"
            >
              Next
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
};
export default SpecimenForm;
